import { z } from "zod";

import { isValidCPF } from "@modules/agreements/utils/isValidCPF";
import { isValidCNPJ } from "@modules/agreements/utils/isValidCNPJ";

export const partnerSchema = () =>
  z.object({
    name: z.string().min(1),
    email: z.string().email(),
    telephone: z.string().min(1),
    document: z
      .string()
      .min(1)
      .refine((value) => isValidCPF(value) || isValidCNPJ(value), {
        message: "Documento inválido",
      }),
    user: z.number().optional().nullable(),
    notes: z.string().optional().nullable(),
    active: z.boolean().optional(),
  });

export type PartnerFormValues = z.infer<ReturnType<typeof partnerSchema>>;
